export let materialList = [
  { en: 'Polyester', cn: '涤纶或化纤（聚酯纤维）', value: '1' },
  { en: 'Elastane/Spandex', cn: '氨纶', value: '2' },
  { en: 'Nylon/Polyamide', cn: '锦纶', value: '3' },
  { en: 'Acrylic', cn: '腈纶', value: '4' },
  { en: 'Acetate', cn: '醋酸', value: '5' },
  { en: 'Cotton', cn: '棉', value: '6' },
  { en: 'Rayon', cn: '人棉', value: '7' },
  { en: 'Viscose', cn: '粘胶纤维', value: '8' },
  { en: 'Cashmere', cn: '羊绒', value: '9' },
  { en: 'Wool', cn: '羊毛', value: '10' },
  { en: 'Mohair', cn: '马海毛', value: '11' },
  { en: 'Rabbit Hair', cn: '兔毛RH', value: '12' },
  { en: 'Alpaca', cn: '羊驼毛', value: '13' },
  { en: 'Camel Hair', cn: '驼毛', value: '14' },
  { en: 'Llama wool', cn: '羊羔毛', value: '15' },
  { en: 'Jute', cn: '黄麻', value: '16' },
  { en: 'Linen', cn: '亚麻', value: '17' },
  { en: 'Ramie', cn: '苎麻', value: '18' },
  { en: 'Hemp', cn: '大麻', value: '19' },
  { en: 'Imitated Silk Fabric', cn: '仿真丝', value: '20' },
  { en: 'Filament', cn: '长丝', value: '21' },
  { en: 'Spun', cn: '短纤', value: '22' },
  { en: 'Black Yarn', cn: '黑丝', value: '23' },
  { en: 'Cation', cn: '阳离子', value: '24' },
  { en: 'Polyurethane (pu)', cn: 'PU皮（聚氨酯)', value: '25' },
  { en: 'Silk', cn: '丝绸', value: '26' }
]
